import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import { styled } from '@mui/material/styles';

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  color: '#fff',
}));

export const DropPage = ({ children }: { children: React.ReactNode }) => {
  return (
    <div>
      <StyledBackdrop open>{children}</StyledBackdrop>
    </div>
  );
};
